export const AuthenticationType = {
    IdCard: "idCard",
    SmartId: "smartId",
    MobileId: "mobileId",
    EParakstsMobile: "eParakstsMobile",
    EParakstsIdCard: "eParakstsIdCard"
};
